import { z } from "zod";
export const importEntraUsersSchema = z.object({
    users: z
        .array(z.object({
        externalId: z.string(),
        email: z.string().email(),
        displayName: z.string().optional(),
    }))
        .min(1),
});
export const importEntraGroupsSchema = z.object({
    groups: z
        .array(z.object({
        externalId: z.string(),
        displayName: z.string(),
    }))
        .min(1),
});
//# sourceMappingURL=entra-sync.js.map